import {createEntityAdapter, EntityAdapter, EntityState} from "@ngrx/entity";
import {VersionEventModel} from "@services/notifications/model/versionEventModel";
import {PaginationModel} from "@shared/models/pagination.model";
import {ConfigService} from "@config/config.service";
import {VersionHistoryActions, VersionHistoryActionTypes} from "@references/ngrx/actions/version-history.actions";

export const adapter: EntityAdapter<VersionEventModel> = createEntityAdapter<VersionEventModel>();

export interface State extends EntityState<VersionEventModel> {
    loading: boolean,
    pagination: PaginationModel,
}

export const initialState: State = adapter.getInitialState( {
    loading: false,
    pagination: {
        first: true,
        last: false,
        number: 0,
        numberOfElements: 0,
        size: new ConfigService().paginationConfig.pageSize,
        totalElements: 0,
    }
});

export function reducer(state = initialState, action: VersionHistoryActions): State {
    switch (action.type) {
        case VersionHistoryActionTypes.LoadVersionHistory:
            return {...state, loading: !action.payload?.dontShowLoading};

        case VersionHistoryActionTypes.LoadVersionHistorySuccess:
            return adapter.setAll(action.payload.content!, {
                ...state,
                loading: false,
                pagination: {
                    size: action.payload.size,
                    last: action.payload.last,
                    totalElements: action.payload.totalElements,
                    numberOfElements: action.payload.numberOfElements,
                    first: action.payload.first,
                    number: action.payload.number,
                },
            });

        case VersionHistoryActionTypes.LoadVersionHistoryFailure:
            return {...state, loading: false};

        case VersionHistoryActionTypes.ChangePage:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    number: action.payload.number,
                    size: action.payload.size,
                }
            };

        case VersionHistoryActionTypes.EditVersion:
            return {...state};

        case VersionHistoryActionTypes.EditVersionSuccess:
            return adapter.updateOne({
                id: action.payload.id!,
                changes: action.payload,
            }, {...state});

        case VersionHistoryActionTypes.EditVersionFailure:
            return {...state};

        case VersionHistoryActionTypes.SetInitialState:
            return {...initialState};

        default:
            return state;
    }
}

export const {
    selectIds: selectVersionHistoryIds,
    selectEntities: selectVersionHistoryEntities,
    selectAll: selectAllVersionHistory,
} = adapter.getSelectors();
